import React, { useRef, useMemo, useEffect } from 'react';
import ClassNames from 'classnames';
import { useLocalization } from '@appkit4/react-api';
import { getLocalizationMonth, getLocalizationWeekday } from '../../utils/dateFormatter';
var Tile = function Tile(props) {
  var tileRef = useRef();
  var children = props.children,
    classes = props.classes,
    date = props.date,
    formatAbbr = props.formatAbbr,
    locale = props.locale,
    maxDate = props.maxDate,
    minDate = props.minDate,
    onClick = props.onClick,
    onMouseOver = props.onMouseOver,
    style = props.style,
    view = props.view,
    tabIndex = props.tabIndex,
    dateValidator = props.dateValidator,
    disabledDates = props.disabledDates,
    disabledDays = props.disabledDays,
    disabledRanges = props.disabledRanges,
    mergedDisabledDatesIntervals = props.mergedDisabledDatesIntervals;
  var isDayExcluded = dateValidator.isDayExcluded,
    isDayInRange = dateValidator.isDayInRange,
    isMonthExcluded = dateValidator.isMonthExcluded,
    isMonthInRange = dateValidator.isMonthInRange,
    isYearInRange = dateValidator.isYearInRange,
    isYearExcluded = dateValidator.isYearExcluded;
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  useEffect(function () {
    if (tabIndex === 0) {
      setTimeout(function () {
        tileRef.current && tileRef.current.focus();
      }, 0);
    }
  }, [tabIndex]);
  var isNeighboring = classes.indexOf('ap-single-day--neighboringMonth') !== -1;
  var disabled = useMemo(function () {
    var _disabled = false;
    if (view === "month") {
      _disabled = !isDayInRange(date, minDate, maxDate) || isDayExcluded(date, {
        disabledDates: disabledDates,
        disabledDays: disabledDays,
        disabledRanges: disabledRanges
      });
    }
    if (view === "year") {
      _disabled = !isMonthInRange(date, minDate, maxDate) || isMonthExcluded(date, mergedDisabledDatesIntervals);
    }
    if (view === 'decade') {
      _disabled = !isYearInRange(date, minDate, maxDate) || isYearExcluded(date, mergedDisabledDatesIntervals);
    }
    return _disabled || isNeighboring;
  }, [date, minDate, maxDate, disabledDates, disabledDays, disabledRanges, mergedDisabledDatesIntervals]);
  //disable only for month-day

  /*const content = formatAbbr ?
    (<abbr aria-label={formatAbbr(locale, date)}> {children} </abbr>) : children;*/

  var setAriaLabel = function setAriaLabel() {
    var result;
    if (locale && formatAbbr) {
      result = formatAbbr(locale, date);
    } else {
      if (view === 'month' && formatAbbr) {
        var _dateLabel, _dateLabel$replace$re;
        var keys = formatAbbr(locale, date).split(',');
        var keys2 = keys[1].split(' ');
        result = (_dateLabel = t('aria').dateLabel) === null || _dateLabel === void 0 ? void 0 : (_dateLabel$replace$re = _dateLabel.replace('{dayName}', t("dayNames")[getLocalizationWeekday(keys[0])]).replace('{monthName}', t("monthNames")[getLocalizationMonth(keys2[1])])) === null || _dateLabel$replace$re === void 0 ? void 0 : _dateLabel$replace$re.replace('{date}', keys2[2]).replace('{year}', keys[2].replace(" ", ""));
      } else if (view === 'year' && formatAbbr) {
        var _monthLabel;
        var _keys = formatAbbr(locale, date);
        result = (_monthLabel = t('aria').monthLabel) === null || _monthLabel === void 0 ? void 0 : _monthLabel.replace('{year}', _keys[0]).replace('{monthName}', t("monthNames")[getLocalizationMonth(_keys[1])]);
      } else if (view === 'decade' && formatAbbr) {
        result = children;
      } else {
        result = '';
      }
    }
    return result;
  };
  return /*#__PURE__*/React.createElement("button", {
    className: ClassNames(classes, {
      'ap-single-day--excluded': disabled
    }),
    "aria-disabled": disabled,
    role: "button",
    onClick: onClick && function (e) {
      if (!disabled) {
        onClick(date, e, false);
      }
    },
    onMouseOver: onMouseOver && function () {
      return onMouseOver(date);
    },
    onFocus: onMouseOver && function () {
      return onMouseOver(date);
    },
    style: style,
    "aria-hidden": isNeighboring,
    type: "button",
    tabIndex: tabIndex,
    "aria-label": setAriaLabel(),
    ref: tileRef
  }, children);
};
export default Tile;